import { Star } from 'lucide-react'
import { cn } from '@/lib/utils'

export type TrustBannerPlacement = 'fixed' | 'static'

type TrustBannerProps = {
  ratingLabel: string
  profilesLabel: string
  placement?: TrustBannerPlacement
  className?: string
}

/**
 * Social proof strip (green primary bar + stars) matching latest results paywall.
 * Use `fixed` + spacer for layouts that need content cleared below a sticky top bar.
 */
export function TrustBanner({
  ratingLabel,
  profilesLabel,
  placement = 'fixed',
  className,
}: TrustBannerProps) {
  return (
    <>
      <div
        className={cn(
          'bg-primary text-background z-50 w-full',
          placement === 'fixed' && 'fixed top-0 inset-x-0',
          className,
        )}
        role="region"
        aria-label={ratingLabel}
      >
        <div className="mx-auto flex max-w-3xl items-center justify-center gap-1 px-2 py-2 sm:gap-1.5 sm:px-3">
          <div className="flex shrink-0 items-center gap-px sm:gap-0.5" aria-hidden>
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-2.5 w-2.5 fill-background text-background sm:h-3 sm:w-3" />
            ))}
          </div>
          <span className="font-heading whitespace-nowrap text-[13px] font-extrabold tracking-[0.5px] uppercase sm:text-sm">
            {ratingLabel}
          </span>
          <span className="text-xs text-background/70">·</span>
          <span className="font-body whitespace-nowrap text-[11px] font-bold sm:text-xs">
            {profilesLabel}
          </span>
        </div>
      </div>
      {placement === 'fixed' ? <div className="h-9 shrink-0" aria-hidden /> : null}
    </>
  )
}
